export interface IconConfig {
  ionicon: string;
  emoji: string;
  text: string;
}

export const iconRegistry: Record<string, IconConfig> = {
  // Car icons
  car: {
    ionicon: "car",
    emoji: "🚗",
    text: "C",
  },
  "car-outline": {
    ionicon: "car-outline",
    emoji: "🚙",
    text: "C",
  },

  // Key icons
  key: {
    ionicon: "key",
    emoji: "🔑",
    text: "K",
  },
  "key-outline": {
    ionicon: "key-outline",
    emoji: "🗝️",
    text: "K",
  },

  // Construction/maintenance icons
  construct: {
    ionicon: "construct",
    emoji: "🔧",
    text: "M",
  },
  "construct-outline": {
    ionicon: "construct-outline",
    emoji: "⚒️",
    text: "M",
  },

  // Status icons
  "checkmark-circle": {
    ionicon: "checkmark-circle",
    emoji: "✅",
    text: "✓",
  },
  alert: {
    ionicon: "alert-circle",
    emoji: "⚠️",
    text: "!",
  },
  "help-circle": {
    ionicon: "help-circle",
    emoji: "❓",
    text: "?",
  },
  "help-circle-outline": {
    ionicon: "help-circle-outline",
    emoji: "❔",
    text: "?",
  },

  // Add/action icons
  "add-circle": {
    ionicon: "add-circle",
    emoji: "➕",
    text: "+",
  },

  // Card/payment icons
  card: {
    ionicon: "card",
    emoji: "💳",
    text: "$",
  },

  // Speed/performance icons
  speedometer: {
    ionicon: "speedometer",
    emoji: "⚡",
    text: "S",
  },

  // Barcode/VIN icons
  barcode: {
    ionicon: "barcode",
    emoji: "🏷️",
    text: "B",
  },

  // Search and clear icons
  search: {
    ionicon: "search",
    emoji: "🔎",
    text: "S",
  },
  'close-circle': {
    ionicon: 'close-circle',
    emoji: '✖️',
    text: '×',
  },

  // Calendar/time icons
  calendar: {
    ionicon: "calendar",
    emoji: "📅",
    text: "D",
  },

  // People icons
  people: {
    ionicon: "people",
    emoji: "👥",
    text: "P",
  },
  "people-outline": {
    ionicon: "people-outline",
    emoji: "👥",
    text: "P",
  },
  person: {
    ionicon: "person",
    emoji: "👤",
    text: "P",
  },

  // Money/cash icons
  cash: {
    ionicon: "cash",
    emoji: "💰",
    text: "$",
  },

  // Location icons
  location: {
    ionicon: "location",
    emoji: "📍",
    text: "L",
  },

  // Security/shield icons
  "shield-checkmark": {
    ionicon: "shield-checkmark",
    emoji: "🛡️",
    text: "S",
  },

  // Lists
  list: {
    ionicon: "list",
    emoji: "📋",
    text: "L",
  },

  // Business/Organization
  business: {
    ionicon: "business",
    emoji: "🏢",
    text: "B",
  },

  // Trash/Delete
  trash: {
    ionicon: "trash",
    emoji: "🗑️",
    text: "D",
  },

  // Settings
  settings: {
    ionicon: "settings",
    emoji: "⚙️",
    text: "S",
  },

  // Refresh/Resend
  refresh: {
    ionicon: "refresh",
    emoji: "🔄",
    text: "R",
  },

  // Back/Arrow
  "arrow-back": {
    ionicon: "arrow-back",
    emoji: "←",
    text: "<",
  },

  // People circle
  "people-circle": {
    ionicon: "people-circle",
    emoji: "👥",
    text: "P",
  },

  // Analytics
  analytics: {
    ionicon: "analytics",
    emoji: "📊",
    text: "A",
  },

  // Cloud
  cloud: {
    ionicon: "cloud",
    emoji: "☁️",
    text: "C",
  },

  // Logout
  "log-out": {
    ionicon: "log-out",
    emoji: "🚪",
    text: "↪",
  },
};
